export type CommandMenuLinkAction = {
  id: string;
  label: string;
  href: string;
  keywords: string[];
};

export function getCommandMenuSignOutAction(
  isAuthenticated: boolean,
  label: string
): CommandMenuLinkAction | null {
  if (!isAuthenticated) {
    return null;
  }

  return {
    id: 'sign-out',
    label,
    href: '/auth/sign-out',
    keywords: ['sign out', 'logout', 'log out', 'leave account'],
  };
}
